export default __webpack_public_path__ + "static/media/2018.61d25160.gif";